import '@/framework/bootstrap-toolkit.min';
import { PortalBaseViewController } from '@/views/portal/PortalBaseViewController';
import { TTAPI } from '@/services/TimeTrexClientAPI';
import '@/global/widgets/filebrowser/TImageBrowser';
import { ServiceCaller } from '@/services/ServiceCaller';
import { TTUUID } from '@/global/TTUUID';
import { RecruitmentPortalNavigation } from '@/portal/recruitment/RecruitmentPortalNavigation';

export class PortalJobVacancyDetailController extends PortalBaseViewController {
	constructor( options = {} ) {
		_.defaults( options, {
			edit_view_error_ui_dic: {},
			events: {
				'click #applyBtn': 'debouncedOnApplyJobClick', //See debounced event below.
				'click #available_jobs': 'availableJobsClick',
				'click #applied_jobs': 'appliedJobsClick',
				'click #applied_btn': 'appliedJobsClick',
				'click .sign-in': 'signIN'
			}
		} );

		super( options );

		this.is_apply_in_progress = false;
		this.apply_button_default_html = null;
		this.debouncedOnApplyJobClick = _.debounce( this.onApplyJobClick.bind( this ), Global.calcDebounceWaitTimeBasedOnNetwork(), true );

		// Modify the events object so it can be re-bound after super()
		this.events['click #applyBtn'] = 'debouncedOnApplyJobClick';

		// Re-delegate the events
		this.delegateEvents();
	}

	init() {
		this.viewId = 'PortalJobVacancyDetail';
		this.script_name = 'JobVacancyDetailView';
		this.job_applicant_api = TTAPI.APIJobApplicantPortal;
		this.viewport = $.extend( {}, ResponsiveBootstrapToolkit );
		this.render();
	}

	render() {
		var $this = this;
		if ( LocalCacheData.getPortalLoginUser() ) {
			this.setRegisterContainerStatus( function( applied ) {
				$this.showJobVacancy( { applied: applied } );
			} );
		} else {
			this.showJobVacancy();
		}
	}

	showJobVacancy( options ) {
		var $this = this;
		var row = Global.loadWidget( 'views/portal/hr/recruitment/PortalJobVacancyDetail.html' );
		var user_data = { first_name: '', last_name: '', email: '', applied: false };
		if ( LocalCacheData.getPortalLoginUser() ) {
			user_data = {
				first_name: LocalCacheData.getPortalLoginUser().first_name,
				last_name: LocalCacheData.getPortalLoginUser().last_name,
				email: LocalCacheData.getPortalLoginUser().email
			};
		}
		if ( Global.isSet( options ) && Global.isSet( options.applied ) ) {
			user_data.applied = options.applied;
		}
		for ( var key in this.model.attributes ) {
			if ( this.model.get( key ) == false ) {
				this.model.set( key, '' );
			}
		}
		this.$el.html( _.template( row )( $.extend( user_data, this.model.toJSON() ) ) );
		if ( this.$( '#applyBtn' )[0] ) {
			this.apply_button_default_html = this.$( '#applyBtn' ).html();
			this.setApplyButtonProcessing( this.is_apply_in_progress );
		}
		this.$( 'input[type="text"], input[type="email"]' ).each( function() {
			$( this ).unbind( 'focus' ).bind( 'focus', function() {
				$( this ).parent().addClass( 'job-apply-form-focus' );
			} );
		} );
		this.$( 'input[type="text"], input[type="email"]' ).each( function() {
			$( this ).unbind( 'blur' ).bind( 'blur', function() {
				$( this ).parent().removeClass( 'job-apply-form-focus' );
			} );
		} );

		this.setDetailAndApplyFormHeight();
		$( window ).resize(
			$this.viewport.changed( function() {
				$this.setDetailAndApplyFormHeight();
			} )
		);
		// if ( LocalCacheData.getPortalLoginUser() ) {
		// 	this.setRegisterContainerStatus();
		// } else {
		// 	$this.$('.apply-form .form-group').show();
		// }
		this.uploader = this.$( '.register-resume' ).TImageBrowser( {
			field: 'file',
			name: 'file_data',
			accept_filter: '.pdf,.doc,.docx,.xls,.xlsx,.odt,.rtf,.txt,.html,.htm,.png,.jpg,.jpeg,.tif,.tiff',
			changeHandler: function( a ) {
				var browser_input = $( this ).find( '.browser' )[0];
				var file_name = '';
				if ( browser_input && browser_input.files && browser_input.files[0] ) {
					file_name = browser_input.files[0].name;
				}
				$this.$( '.apply-form #file_name' ).val( file_name );
			}
		} );

		let apply_form = document.querySelector( '.apply-form' );

		if ( apply_form ) {
			Global.initFileDragAndDrop( apply_form, ( files ) => {
				this.attachDragAndDropFile( files );
			} );
		}

		// start- from html PortalJobVacancyDetail.html


		$( '.apply-form' ).unbind( 'keydown' ).bind( 'keydown', function( e ) {
			if ( e.keyCode === 13 ) {
				e.preventDefault();
				$this.debouncedOnApplyJobClick();
			}
		} );

		// end - from html
	}

	attachDragAndDropFile( files ) {
		if ( !files || !files[0] || !this.uploader || !this.uploader[0] ) {
			this.$( '.apply-form #file_name' ).val( '' );
			return;
		}

		//Only add the first file
		let data_transfer = new DataTransfer();
		data_transfer.items.add( files[0] );

		let uploader_input = this.uploader[0].querySelector( 'input' );
		if ( !uploader_input ) {
			this.$( '.apply-form #file_name' ).val( '' );
			return;
		}

		uploader_input.files = data_transfer.files;
		this.$( '.apply-form #file_name' ).val( files[0].name );
	}

	setDetailAndApplyFormHeight() {
		var detail_panel_header_height = this.$( '.job-header' ).height();
		var apply_form__header_height = this.$( '.job-apply' ).height();
		if ( this.viewport.is( 'md' ) || this.viewport.is( '>md' ) ) {
			if ( detail_panel_header_height !== apply_form__header_height ) {
				if ( detail_panel_header_height > apply_form__header_height ) {
					this.$( '.job-apply' ).height( detail_panel_header_height - 20 );
				} else {
					this.$( '.job-header' ).height( apply_form__header_height + 20 );
				}
			}
		} else if ( this.viewport.is( '<=sm' ) ) {
			this.$( '.job-apply' ).height( 70 );
		}
	}

	setApplyButtonProcessing( is_processing ) {
		this.is_apply_in_progress = is_processing === true;

		var apply_button = this.$( '#applyBtn' );
		if ( !apply_button[0] ) {
			return;
		}

		if ( !this.apply_button_default_html ) {
			this.apply_button_default_html = apply_button.html();
		}

		if ( this.is_apply_in_progress ) {
			apply_button.prop( 'disabled', true ).attr( 'aria-disabled', 'true' ).addClass( 'disabled' );
			apply_button.html( $.i18n._( 'Applying' ) + '...' );
		} else {
			apply_button.prop( 'disabled', false ).removeAttr( 'aria-disabled' ).removeClass( 'disabled' );
			apply_button.html( this.apply_button_default_html );
		}
	}

	onApplyJobClick() {
		var $this = this;
		if ( this.is_apply_in_progress ) {
			return;
		}

		this.setApplyButtonProcessing( true );
		if ( LocalCacheData.getPortalLoginUser() ) {
			this.getJobApplication( function( result ) {
				if ( result && result.isValid() ) {
					var result_data = result.getResult();
					if ( !Global.isArray( result_data ) ) {
						result_data = [];
					}
					if ( result_data.length > 0 ) {
						RecruitmentPortalNavigation.goToPortalView( 'MyProfile', {}, { remove_args: [ 'id' ] } );
					} else {
						$this.applyToCurrentJobVacancy();
					}
				} else {
					$this.setApplyButtonProcessing( false );
				}
			} );
		} else {
			this.registerNewUser( function( user_name, password ) {
				var recruitment_api = TTAPI.APIRecruitmentAuthentication;
				recruitment_api.Login( user_name, password, {
					onResult: function( e ) {
						if ( e && e.isValid && e.isValid() ) {
							$this.onLoginSuccess( e );
						} else {
							$this.setApplyButtonProcessing( false );
							$this.showValidateErrorTips( e );
						}
					}
				} );
			} );
		}
	}

	availableJobsClick() {
		RecruitmentPortalNavigation.goToPortalView( 'PortalJobVacancy', {}, { remove_args: [ 'id' ] } );
	}

	appliedJobsClick() {
		RecruitmentPortalNavigation.goToPortalView( 'MyJobApplication', {}, { remove_args: [ 'id' ] } );
	}

	signIN() {
		var sign_controller = new SignInController( {
			_delegate: this
		} );
	}

	onLoginSuccess( e, session_id ) {
		var result;
		var $this = this;
		if ( !session_id ) {
			result = e.getResult();
		} else {
			result = session_id;
		}
		ServiceCaller.cancel_all_error = false;
		LocalCacheData.setSessionID( result );
		setCookie( Global.getSessionIDKey(), result );
		var jobapplicant_api = TTAPI.APIJobApplicantPortal;
		jobapplicant_api.getJobApplicant( {
			onResult: function( result ) {
				if ( result && result.isValid() ) {
					LocalCacheData.setPortalLoginUser( result.getResult()[0] );
					IndexViewController.instance.router.headerView.render();
					$this.applyToCurrentJobVacancy();
				} else {
					$this.setApplyButtonProcessing( false );
					ProgressBar.closeOverlay();
				}
			}
		} );
	}

	setRegisterContainerStatus( callback ) {
		var $this = this;
		this.getJobApplication( function( res ) {
			var result = false;
			if ( res && res.isValid() ) {
				var result_data = res.getResult();
				if ( !Global.isArray( result_data ) ) {
					result_data = [];
				}
				if ( result_data.length > 0 ) {
					// $this.$('.apply-form .form-group').hide();
					// $this.hideApplyForm();
					result = true;
				}
			}
			callback( result );
		} );
	}

	// hideApplyForm: function () {
	// 	this.$('.apply-form .form-group').hide();
	// 	this.$('.apply-form button[id="applyBtn"]').text( $.i18n._('Applied')  ).attr('disabled', 'disabled');
	// },

	// showApplyForm: function () {
	// 	this.$('.apply-form .form-group').show();
	// 	this.$('.apply-form button[id="applyBtn"]').html( $.i18n._('Apply') + '<span class="glyphicon glyphicon-menu-right" aria-hidden="true"></span>' ).removeAttr('disabled');
	// },

	getJobApplication( callback ) {
		var $this = this;
		var filter = {};
		filter.filter_data = {};
		filter.filter_data.job_vacancy_id = this.model.id;
		this.job_applicant_api.getJobApplication( filter, {
			onResult: function( result ) {
				callback( result );
			}
		} );
	}

	saveCurrentJobVacancy( callback ) {
		var $this = this;
		var record = {};
		record.job_vacancy_id = this.model.id;
		this.job_applicant_api.setJobApplication( record, {
			onResult: function( result ) {
				if ( !result.isValid() ) {
					$this.setApplyButtonProcessing( false );
					$this.showValidateErrorTips( result );
				} else {
					if ( callback ) {
						callback( result );
					} else {
						$this.render();
					}
				}
			}
		} );
	}

	applyToCurrentJobVacancy() {
		var $this = this;
		this.uploadResume( function() {
			$this.saveCurrentJobVacancy( function() {
				$this.applySuccess();
			} );
		}, function( error ) {
			$this.applyFail( error, false );
		} );
	}

	showAlert( content ) {
		IndexViewController.instance.router.showTipModal( content, {
			style: {
				'border': '2px solid #154575',
				'color': '#154575'
			}
		} );
	}

	uploadResume( success_callback, error_callback ) {
		if ( !this.uploader ) {
			if ( success_callback ) {
				success_callback();
			}
			return true;
		}

		if ( document.getElementById( 'file_browser') !== null ) { //Only try uploading resume if the "Browse" button actually exists. So when the user is already logged in and applying for a position they don't get an error message.
			var uploader = this.uploader;
			var name = uploader.attr( 'file_name' );
			var file = uploader.getValue();
			if ( file ) {
				this.document_api = TTAPI.APIDocumentPortal;
				var document_name = 'Resume' + ' - ' + this.$( '.apply-form input[id="first_name"]' ).val() + ' ' + this.$( '.apply-form input[id="last_name"]' ).val();
				var attachment_result = this.document_api.addAttachment( document_name, '', { async: false } );
				if ( attachment_result && attachment_result.isValid() ) {
					var attachment_data = attachment_result.getResult();
					this.uploadFile( file, attachment_data.document_id, attachment_data.document_revision_id, success_callback, error_callback );
				} else if ( error_callback ) {
					error_callback( $.i18n._( 'Unable to upload resume.' ) );
				}
				return true;
			}
		}

		if ( success_callback ) {
			success_callback();
		}

		return true;
	}

	getProfileURL() {
		return RecruitmentPortalNavigation.getPortalViewURL( 'MyProfile', {}, { remove_args: [ 'id' ] } );
	}

	applySuccess() {
		var content = $( '<div>' );
		content.append( '<p><strong>' + $.i18n._( 'Application sent successfully!' ) + '</strong></p>' );
		content.append( '<p>' + $.i18n._( 'Please ensure all sections of your profile are accurate and complete.' ) + '</p>' );
		this.showAlert( content );
		RecruitmentPortalNavigation.goToPortalView( 'MyProfile', {}, { remove_args: [ 'id' ] } );
	}

	applyFail( error, redirect = false ) {
		if ( redirect !== true ) {
			this.setApplyButtonProcessing( false );
		}

		var content = $( '<div>' );
		content.append( '<p><strong><font color="red">' + error + '</font></strong></p>' );
		if ( redirect ) {
			content.append( '<p>' + $.i18n._( 'Please complete your profile and ensure all information is accurate and complete.' ) + '</p>' );
		} else {
			content.append( '<p>' + $.i18n._( 'Please correct the error above and try again.' ) + '</p>' );
		}
		this.showAlert( content );
		if ( redirect ) {
			RecruitmentPortalNavigation.goToPortalView( 'MyProfile', {}, { remove_args: [ 'id' ] } );
		}
	}

	uploadFile( file_data, document_id, document_revision_id, success_callback, error_callback ) {
		var $this = this;
		var url = ServiceCaller.getAPIURL( 'Class=' + this.document_api.className + '&Method=uploadAttachment' + '&v=2' );
		if ( LocalCacheData.getAllURLArgs().company_id ) {
			url = url + '&company_id=' + LocalCacheData.getAllURLArgs().company_id;
		}
		url = url + '&object_id=' + document_revision_id;
		var message_id = TTUUID.generateUUID();
		ProgressBar.showProgressBar( message_id );
		ProgressBar.changeProgressBarMessage( 'File Uploading' );
		$.ajax( {
			url: url, //Server script to process data
			headers: {
				//Handle CSRF tokens and related headers here.
				'X-Client-ID': 'Browser-TimeTrex',
				'X-CSRF-Token': getCookie( 'CSRF-Token' ),
			},
			type: 'POST',
			data: file_data,
			success: function( res ) {
				ProgressBar.removeProgressBar();
				if ( res.error == '' ) {
					if ( success_callback ) {
						success_callback();
					}
				} else {
					$this.job_applicant_api.deleteDocument( document_id, { async: false } );
					if ( error_callback ) {
						error_callback( res.error );
					}
				}
			},
			error: function() {
				ProgressBar.removeProgressBar();
				$this.job_applicant_api.deleteDocument( document_id, { async: false } );
				if ( error_callback ) {
					error_callback( $.i18n._( 'Upload failed.' ) );
				}
			},
			cache: false,
			contentType: false,
			processData: false
		} );
	}

	registerNewUser( callBack ) {
		var $this = this;
		var data = {};
		data.first_name = this.$( '.apply-form input[id="first_name"]' ).val();
		data.last_name = this.$( '.apply-form input[id="last_name"]' ).val();
		data.user_name = this.$( '.apply-form input[id="email"]' ).val();
		data.email = data.user_name;
		data.password = Math.random().toString( 36 ).replace( /[^a-z0-9]+/g, '' ); //Use a random password for new users.
		data.company_id = LocalCacheData.getAllURLArgs().company_id;
		if ( this.$( '.apply-form input[id="email"]' ).val() === this.$( '.apply-form input[id="confirm_email"]' ).val() ) {
			if ( this.edit_view_error_ui_dic.hasOwnProperty( 'confirm_email' ) ) {
				Global.removeErrorTips( [ this.edit_view_error_ui_dic['confirm_email'][0] ], true );
			}
			if ( data.first_name != '' && data.last_name != '' && data.email != '' ) {
				if ( !this.uploader.getValue() ) {
					IndexViewController.instance.router.showConfirmModal( $.i18n._( 'A resume is highly recommended for this position. Applying without one may reduce your chances. Are you sure you want to proceed?' ), {
						title: '',
						actions: [
							{
								label: 'No', isClose: true, callBack: function( e ) {
									$this.setApplyButtonProcessing( false );
									return;
								}
							},
							{
								label: 'Yes', callBack: function( e ) {
									IndexViewController.instance.router.hideConfirmModal();
									$this.setJobApplicant( data, callBack );
								}
							}
						]
					} );
					return;
				}
			}
			this.setJobApplicant( data, callBack );
		} else {
			this.removeValidateErrorTips();
			var field_obj = this.$( '.apply-form' ).find( 'input[id="confirm_email"]' );
			field_obj[0].classList.add( 'error-tip' );

			const tooltip = new bootstrap.Tooltip( field_obj[0], {
				title: 'Confirm email does not match email', // Replace this with the appropriate translation function if needed
			} );

			if ( tooltip ) {
				tooltip.show();
			}
			this.edit_view_error_ui_dic['confirm_email'] = field_obj;
			this.setApplyButtonProcessing( false );
		}
	}

	setJobApplicant( data, callBack ) {
		var $this = this;
		this.job_applicant_api.setIsIdempotent( true ); //Force to idempotent API call to avoid duplicate network requests from causing errors displayed to the user.
		this.job_applicant_api.setJobApplicant( data, {
			onResult: function( result ) {
				if ( result && result.isValid() ) {
					$this.removeValidateErrorTips();
					$this.edit_view_error_ui_dic = {};
					callBack( data.user_name, data.password );
				} else {
					$this.setApplyButtonProcessing( false );
					$this.showValidateErrorTips( result );
				}
			}
		} );
	}

	showValidateErrorTips( result, stepsWidgetDic ) {
		if ( !result || !result.getDetails ) {
			return false;
		}

		const details = result.getDetails() || result.getDescription();

		if ( Global.isArray( details ) || typeof details === 'object' ) {
			this.removeValidateErrorTips();

			Object.values( details ).forEach( ( val ) => {
				if ( val.hasOwnProperty( 'error' ) ) {
					val = val.error;
				}

				for ( let key in val ) {
					if ( !val.hasOwnProperty( key ) ) {
						continue;
					}

					let error_string = '';
					if ( key === 'user_name' ) {
						key = 'email';
						error_string = $.i18n._( 'Email address already exists, please login instead' );
					}

					let field_obj = null;
					if ( this.$( '.apply-form' ).find( `input[id="${key}"]` )[0] ) {
						field_obj = this.$( '.apply-form' ).find( `input[id="${key}"]` );
					} else {
						field_obj = this.$( '.apply-form' );
					}

					if ( field_obj ) {
						field_obj.addClass( 'error-tip' );
						if ( !error_string ) {
							error_string = _.isArray( val[key] ) ? val[key][0] : val[key];
						}
						field_obj.attr( { 'title': error_string, 'data-bs-original-title': error_string } );
						const tooltip = new bootstrap.Tooltip( field_obj[0], {
							'title': error_string,
						} );
						tooltip.show();
						this.edit_view_error_ui_dic[key] = field_obj;
					}
				}
			} );
		}
		return false;
	}

	removeValidateErrorTips() {
		const tips_to_remove = [];

		for ( const key in this.edit_view_error_ui_dic ) {
			if ( key === 'email' || key === 'confirm_email' ) {
				continue;
			}
			tips_to_remove.push( this.edit_view_error_ui_dic[key] );
		}

		Global.removeErrorTips( tips_to_remove.map( item => item[0] ), true );
	}

}
